import { TemplateElement, html } from '@webtides/element-js';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import { classMap } from 'lit-html/directives/class-map.js';

import style from './frame-selector.css';
import FrameSelectorEvent from './FrameSelectorEvent';

import FRAMES from './Frames';
import '../../../legacy-library/webcomponents/arrow-box-trigger/arrow-box-trigger';
import '../../elements/horizontal-scroll/horizontal-scroll';

export default class FrameSelector extends TemplateElement {
    constructor() {
        super({ shadowRender: false, styles: [style] });
    }

    properties() {
        return {
            frames: [
                'RAICO_CARGO',
                'RAICO_DIAMANT',
                'RAICO_COMPACT',
                'RAICO_TRAPEZ',
                'RAICO_TIEF',
                'RAICO_KIDS',
                'RAICO_Y',
                'RAICO_DEEPWAVE',
            ],
            labels: [],
            activeFrame: false,
            compact: true,
            showAllFrames: false,
            allFramesLabel: 'ALLE',
            allFramesMobileLabel: '',
            moreLinkHtml: false,
            borderBottom: true,
        };
    }

    connected() {
        this.requestUpdate();
    }

    afterUpdate() {
        this.$refs.hover.disabled = false;
        //delay this one tick as nested frames are renderd async and might not have dimensions on first paint
        requestAnimationFrame(() => this.$refs.hover.resetCssProperties());
    }

    events() {
        return {
            '.frame': {
                click: ev => {
                    const { frame } = ev.currentTarget.dataset;

                    if (frame !== this.activeFrame) {
                        this.activeFrame = frame;
                        this.dispatch(FrameSelectorEvent.FRAME_CLICK, frame);
                    }
                },
            },
        };
    }

    get activeFrameIndex() {
        const index = this.allFrames.findIndex(row => row === this.activeFrame);
        return Math.max(0, index);
    }
    get allFrames() {
        if (this.showAllFrames) {
            return ['ALL', ...this.frames];
        }
        return this.frames;
    }

    getFrameIcon(frame, index) {
        if (!FRAMES[frame.toUpperCase()]) {
            //no icon fallback to label and frame id
            return this.labels[index] || frame.toUpperCase();
        }

        if (this.labels[index]) {
            return html`
                <arrow-box-trigger
                    label="${this.labels[index]}"
                    arrow-class="font-normal text-sm whitespace-nowrap z-50"
                >
                    ${FRAMES[frame.toUpperCase()](this)}
                </arrow-box-trigger>
            `;
        }
        return FRAMES[frame.toUpperCase()](this);
    }

    showMoreLinkTemplate() {
        if (!this.moreLinkHtml) return '';
        return html` ${unsafeHTML(this.moreLinkHtml)} `;
    }

    template() {
        return html`
            <horizontal-scroll selector=".scroll-item" active="${this.activeFrameIndex}">
                <hover-indicator
                    ref="hover"
                    disabled="true"
                    selector=".scroll-item"
                    class="w-full flex"
                    active="${this.activeFrameIndex}"
                >
                    ${this.allFrames.map((frame, index) => {
                        const classes = {
                            active: this.activeFrameIndex === index,
                            'p-2': this.compact,
                            'p-5': !this.compact,
                        };
                        return html`
                            <div
                                class="frame scroll-item cursor-pointer flex items-center hover-bg-accent arrow-box-hover
                                ${classMap(classes)}"
                                data-frame="${frame}"
                            >
                                ${this.getFrameIcon(frame, index)}
                            </div>
                        `;
                    })}
                    <div class="scroll-item flex items-center">${this.showMoreLinkTemplate()}</div>
                </hover-indicator>
            </horizontal-scroll>
        `;
    }
}
